const gaAction = {};

gaAction.select_content = (data) => {
    // console.log(data);
    let gaData = {
        id: "",
        name: data.name,
        list_name: data.list_name,
        variant: data.colorText,
        list_position: data.list_position + 1,
        price: 0
    };
    if (data.hasOwnProperty("id")) {
        gaData.id = data.id
    }
    else {
        gaData.id = data.baseId
    }
    if (data.hasOwnProperty("price")) {
        gaData.price = data.price
    }
    else {
        gaData.price = data.joinPrice
    }
    gtag('event', 'select_content', {
        content_type: "product",
        items: [gaData]
    });
};
gaAction.view_item = (data, url) => {
    // console.log("view_item", data, url);
    let gaData = [];
    for (let i in data) {
        gaData.push({})
    }
    for (let i in data) {
        if (data[i].hasOwnProperty("id")) {
            gaData[i].id = data[i].id;
        }
        else {
            gaData[i].id = data[i].baseId;
        }
        gaData[i].name = data[i].name;
        gaData[i].list_name = url;
        gaData[i].variant = data[i].colorText;
        gaData[i].list_position = i * 1 + 1;
        if (data[i].hasOwnProperty("price")) {
            gaData[i].price = data[i].price;
        }
        else {
            gaData[i].price = data[i].joinPrice;
        }
    }
    // console.log(gaData);
    gtag("event", "view_item", {
        items: gaData
    });
};
gaAction.view_item_list = (data, url) => {
    // console.log("view_item_list", data)
    let gaData = [];
    for (let i in data) {
        gaData.push({})
    }
    for (let i in data) {
        if (data[i].hasOwnProperty("id")) {
            gaData[i].id = data[i].id;
        }
        else {
            gaData[i].id = data[i].baseId;
        }
        gaData[i].name = data[i].name;
        gaData[i].list_name = url;
        gaData[i].list_position = i * 1 + 1;
        gaData[i].price = data[i].price;
        gaData[i].variant = data[i].colorText;
    }
    gtag("event", "view_item_list", {
        items: gaData
    });
};
gaAction.search = (searchText) => {
    gtag("event", "search", {
        search_term: searchText
    });
};
gaAction.add_to_wishlist = (data, url) => {
    // console.log("add_to_wishlist", data)
    let gaData = {
        id: "",
        name: "",
        list_name: "",
        variant: "",
        price: ""
    };
    if (data.hasOwnProperty("id")) {
        gaData.id = data.id;
    }
    else {
        gaData.id = data.baseId;
    }
    gaData.name = data.name;
    gaData.list_name = url;
    gaData.variant = data.colorText;
    if (data.hasOwnProperty("price")) {
        gaData.price = data.price;
    }
    else {
        gaData.price = data.joinPrice
    }
    // console.log(gaData);
    gtag("event", "add_to_wishlist", {
        items: [gaData]
    });
};
gaAction.add_to_cart = (data, url) => {
    // console.log(data, url);
    let gaData = {
        id: "",
        name: "",
        list_name: "",
        variant: "",
        price: ""
    };
    if (data.hasOwnProperty("skuId")) {
        gaData.id = data.skuId;
    }
    else {
        gaData.id = data.id;
    }
    gaData.name = data.name;
    gaData.list_name = url;
    gaData.variant = data.colorText;
    gaData.price = data.price;
    gtag("event", "add_to_cart", {
        items: [gaData]
    });
};
gaAction.remove_from_cart = (data) => {
    // console.log(data);
    let gaData = {
        id: "",
        name: "",
        variant: "",
        price: ""
    };
    gaData.id = data.skuId;
    gaData.name = data.name;
    gaData.variant = data.colorText;
    gaData.price = data.joinPrice;
    gtag("event", "remove_from_cart", {
        items: [gaData]
    });
};
gaAction.begin_checkout = (data, payAmount) => {
    // console.log("begin_checkout", data)
    let gaData = [];
    for (let i in data) {
        gaData.push({})
    }
    for (let i in data) {
        gaData[i].id = data[i].skuId;
        gaData[i].name = data[i].name;
        gaData[i].variant = data[i].colorText;
        gaData[i].price = data[i].joinPrice;
    }
    gtag("event", "begin_checkout", {
        value: payAmount,
        currency: "CNY",
        items: gaData
    });
};
gaAction.checkout_progress = (data, payAmount) => {
    // console.log("checkout_progress", data, payAmount)
    let gaData = [];
    for (let i in data) {
        gaData.push({})
    }
    for (let i in data) {
        gaData[i].id = data[i].id;
        gaData[i].name = data[i].name;
        gaData[i].variant = data[i].colorText;
        gaData[i].price = data[i].price;
    }
    gtag("event", "checkout_progress", {
        checkout_step: 2,
        value: payAmount,
        currency: "CNY",
        items: gaData
    });
};
gaAction.set_checkout_option = (payAmount, payType) => {
    // console.log("set_checkout_option", payAmount, payType)
    gtag("event", "set_checkout_option", {
        checkout_step: 3,
        checkout_option: payType,
        value: payAmount
    });
};
gaAction.purchase = (data, id, payAmount, shopAmount) => {
    // console.log("purchase", data, id, payAmount, shopAmount)
    let gaData = [];
    for (let i in data) {
        gaData.push({})
    }
    for (let i in data) {
        gaData[i].id = data[i].id;
        gaData[i].name = data[i].name;
        gaData[i].variant = data[i].colorText;
        gaData[i].quantity = data[i].count,
            gaData[i].price = data[i].price;
    }
    gtag("event", "purchase", {
        currency: "CNY",
        transaction_id: id,
        value: payAmount,
        shipping: shopAmount,
        items: gaData
    });
};
gaAction.pageview = (page_title, page_path) => {
    gtag("event", "page_view", {
        page_title: page_title, page_path: page_path
    });
};
gaAction.to404 = () => {
    gtag("event","404_page_view", {
        "event_category": "debug:404_direct_visit",
        "event_action": "visit_page_not_found",
        "event_label": window.location.href
    });
};
gaAction.login = (phone) => {
    console.log("登录成功", phone);
    gtag("event", "login", {
        method: phone
    });
};
gaAction.sign_up = (phone) => {
    console.log("注册成功", phone);
    gtag("event", "sign_up", {
        method: phone
    });
};


export default gaAction;





// WEBPACK FOOTER //
// ./src/utils/gaType.js